<main class="auth-page">

  <aside class="auth-side">
    <div class="auth-side__orb auth-side__orb--top"></div>
    <div class="auth-side__orb auth-side__orb--bottom"></div>

    <div class="auth-side__content">

      <div class="auth-side__eyebrow">
        <span class="auth-side__eyebrow-icon">
          <i class="fi fi-rr-lock"></i>
        </span>

        <span>CREATE A NEW PASSWORD</span>
      </div>

      <h2>
        შექმენი ახალი
        <strong>უსაფრთხო პაროლი</strong>
      </h2>

      <p class="auth-side__description">
        გამოიყენე ძლიერი პაროლი, რომელიც შეიცავს პატარა და დიდ ასოებს,
        ციფრებს და მინიმუმ 8 სიმბოლოს.
      </p>

      <div class="auth-feature-list">

        <div class="auth-feature">
          <span class="auth-feature__check">
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>მინიმუმ 8 სიმბოლო</strong>

            <small>
              გრძელი პაროლი უფრო რთულად გამოსაცნობია.
            </small>
          </div>
        </div>

        <div class="auth-feature">
          <span class="auth-feature__check">
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>ასოებისა და ციფრების კომბინაცია</strong>

            <small>
              გამოიყენე პატარა და დიდი ასოები და მინიმუმ ერთი ციფრი.
            </small>
          </div>
        </div>

        <div class="auth-feature">
          <span class="auth-feature__check">
            <i class="fi fi-rr-check"></i>
          </span>

          <div>
            <strong>არ გამოიყენო ძველი პაროლი</strong>

            <small>
              შექმენი ახალი და უნიკალური პაროლი მხოლოდ Menuload-ისთვის.
            </small>
          </div>
        </div>

      </div>

      <div class="auth-trust-card">
        <span class="auth-trust-card__icon">
          <i class="fi fi-rr-shield-check"></i>
        </span>

        <div>
          <strong>ანგარიშის უსაფრთხოება</strong>

          <small>
            ახალი პაროლის დაყენების შემდეგ ძველი პაროლი აღარ იმუშავებს.
          </small>
        </div>
      </div>

    </div>
  </aside>


  <section class="auth-card">

    <header class="auth-card__header">

      <div class="auth-logo">
        M
      </div>

      <span class="auth-eyebrow">
        PASSWORD RESET
      </span>

      <h1>
        ახალი პაროლის შექმნა
      </h1>

      <p>
        შექმენი ახალი პაროლი და დაადასტურე იგი ქვემოთ.
      </p>

    </header>


    <div
      class="auth-error"
      *ngIf="message"
    >
      <i class="fi fi-rr-exclamation"></i>

      <span>{{ message }}</span>
    </div>


    <form
      class="auth-form"
      [formGroup]="resetPasswordForm"
      (ngSubmit)="resetPassword()"
    >

      <!-- New password -->

      <div class="auth-field">

        <label for="password">
          {{ 'NEW_PASSWORD' | translate }}
        </label>

        <div
          class="auth-input"
          [class.auth-input--invalid]="
            passwordControl?.invalid &&
            (passwordControl?.dirty || passwordControl?.touched)
          "
        >
          <i class="fi fi-rr-lock"></i>

          <input
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            [placeholder]="'NEW_PASSWORD' | translate"
            autocomplete="new-password"
          >

          <button
            type="button"
            class="password-toggle"
            (click)="showPassword = !showPassword"
            aria-label="Show or hide password"
          >
            <i
              [class]="
                showPassword
                  ? 'fi fi-rr-eye-crossed'
                  : 'fi fi-rr-eye'
              "
            ></i>
          </button>
        </div>

        <div
          class="password-strength"
          *ngIf="isTyping"
        >
          <div class="password-strength__track">
            <div
              class="password-strength__bar"
              [class.is-weak]="passwordStrength <= 40"
              [class.is-medium]="
                passwordStrength > 40 &&
                passwordStrength < 80
              "
              [class.is-strong]="passwordStrength >= 80"
              [style.width.%]="passwordStrength"
            ></div>
          </div>

          <small
            class="password-strength__label weak"
            *ngIf="passwordStrength <= 40"
          >
            {{ 'VALIDATION.PASSWORD_STRENGTH_WEAK' | translate }}
          </small>

          <small
            class="password-strength__label medium"
            *ngIf="
              passwordStrength > 40 &&
              passwordStrength < 80
            "
          >
            {{ 'VALIDATION.PASSWORD_STRENGTH_MEDIUM' | translate }}
          </small>

          <small
            class="password-strength__label strong"
            *ngIf="passwordStrength >= 80"
          >
            {{ 'VALIDATION.PASSWORD_STRENGTH_STRONG' | translate }}
          </small>
        </div>

        <div
          class="password-rules"
          *ngIf="isTyping"
        >
          <span [class.is-valid]="hasMinLength()">
            <i
              [class]="
                hasMinLength()
                  ? 'fi fi-rr-check'
                  : 'fi fi-rr-cross-small'
              "
            ></i>

            მინიმუმ 8 სიმბოლო
          </span>

          <span [class.is-valid]="hasLowerCase()">
            <i
              [class]="
                hasLowerCase()
                  ? 'fi fi-rr-check'
                  : 'fi fi-rr-cross-small'
              "
            ></i>

            პატარა ასო
          </span>

          <span [class.is-valid]="hasUpperCase()">
            <i
              [class]="
                hasUpperCase()
                  ? 'fi fi-rr-check'
                  : 'fi fi-rr-cross-small'
              "
            ></i>

            დიდი ასო
          </span>

          <span [class.is-valid]="hasNumber()">
            <i
              [class]="
                hasNumber()
                  ? 'fi fi-rr-check'
                  : 'fi fi-rr-cross-small'
              "
            ></i>

            მინიმუმ ერთი ციფრი
          </span>
        </div>

        <small
          class="field-error"
          *ngIf="
            passwordControl?.hasError('required') &&
            (passwordControl?.dirty || passwordControl?.touched)
          "
        >
          {{ 'VALIDATION.PASSWORD_REQUIRED' | translate }}
        </small>

        <small
          class="field-error"
          *ngIf="
            passwordControl?.hasError('minlength') &&
            (passwordControl?.dirty || passwordControl?.touched)
          "
        >
          {{ 'VALIDATION.PASSWORD_MIN' | translate }}
        </small>

      </div>


      <!-- Confirm password -->

      <div class="auth-field">

        <label for="password_confirmation">
          {{ 'CONFIRM_NEW_PASSWORD' | translate }}
        </label>

        <div
          class="auth-input"
          [class.auth-input--invalid]="
            confirmationControl?.hasError('passwordMismatch') &&
            confirmationControl?.touched
          "
        >
          <i class="fi fi-rr-lock"></i>

          <input
            id="password_confirmation"
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="password_confirmation"
            [placeholder]="'CONFIRM_NEW_PASSWORD' | translate"
            autocomplete="new-password"
          >

          <button
            type="button"
            class="password-toggle"
            (click)="showConfirmPassword = !showConfirmPassword"
            aria-label="Show or hide confirmation password"
          >
            <i
              [class]="
                showConfirmPassword
                  ? 'fi fi-rr-eye-crossed'
                  : 'fi fi-rr-eye'
              "
            ></i>
          </button>
        </div>

        <small
          class="field-error"
          *ngIf="
            confirmationControl?.hasError('required') &&
            confirmationControl?.touched
          "
        >
          პაროლის გამეორება სავალდებულოა.
        </small>

        <small
          class="field-error"
          *ngIf="
            confirmationControl?.hasError('passwordMismatch') &&
            confirmationControl?.touched
          "
        >
          {{ 'VALIDATION.PASSWORD_MISMATCH' | translate }}
        </small>

      </div>


      <button
        type="submit"
        class="auth-submit"
        [disabled]="
          resetPasswordForm.invalid ||
          resetPasswordForm.hasError('passwordMismatch') ||
          loading ||
          !token ||
          !email
        "
      >

        <span
          class="auth-submit__spinner"
          *ngIf="loading"
        ></span>

        <span>
          {{
            loading
              ? 'პაროლი იცვლება...'
              : ('CHANGE_PASSWORD' | translate)
          }}
        </span>

        <i
          class="fi fi-rr-arrow-small-right"
          *ngIf="!loading"
        ></i>

      </button>

    </form>


    <footer class="auth-card__footer">

      <span>
        პაროლი გაგახსენდა?
      </span>

      <a routerLink="/signin">
        {{ 'SIGNIN' | translate }}
      </a>

    </footer>

  </section>

</main>